import {
  Component,
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { Subject, from } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { tracking_preview_model } from '../tracking-model';
import {
  tracking_response_model,
  tracking_response_item_model,
  tracking_response_icon_display_model,
} from './tracking-item.model';
import CryptoJS from 'crypto-js';
import { TrackingService } from '../tracking.service';
import { TrackingItemService } from './tracking-item.service';
import { MatDialog } from '@angular/material/dialog';
import { TrackingItemSignatureDialog } from './tracking-item-signature-dialog/tracking-item-signature-dialog';
import { TrackingItemPhotoDialog } from './tracking-item-photo-dialog/tracking-item-photo-dialog';
import { TrackingItemProofPhotoDialog } from './tracking-item-proof-photo-dialog/tracking-item-proof-photo-dialog';
import { TrackingVerifyPhone } from '../tracking-verify-phone-dialog/tracking-verify-phone-dialog';
import { CoreConfigService } from 'src/app/core/core.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Console } from 'console';
import { TrackingItemRefundCodConsent } from './tracking-item-refund/tracking-item-refund-cod-consent/tracking-item-refund-cod-consent';
import { TrackingItemRefundCodDialog } from './tracking-item-refund/tracking-item-refund-cod-dialog/tracking-item-refund-cod-dialog';
import { TrackingItemRefundCodPdfPreview } from './tracking-item-refund/tracking-item-refund-cod-preview/tracking-item-refund-cod-preview';
import { TrackingVerifyPhoneRefund } from '../tracking-item/tracking-verify-phone-refund-dialog/tracking-verify-phone-refund-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Params } from '@fortawesome/fontawesome-svg-core';
@Component({
  selector: 'kett-tracking-item',
  templateUrl: './tracking-item.component.html',
  styleUrls: ['./tracking-item.component.scss'],
})
export class TrackingItemComponent implements OnInit, OnDestroy {
  @Input() index: number;
  @Input() tracking_data: tracking_preview_model;
  ListDoneStatus: string[] = ['112', 'POD', '400', '401'];
  ListVerifyPhone: string[] = [];
  ListVerifyPhoneCOD: string[] = [];
  numbers: string[] = [];
  isExpand = false;
  pdfUrl: SafeResourceUrl;
  showIframe = false;
  isAccept: any;

  private ngDestroyed$ = new Subject<void>();
  @Input() info: tracking_response_item_model = undefined;
  @Input() showdetail = false;
  @Input() IsNotFound = false;
  @Input() kcIcon = '';
  @Output() ChangeShowDetail = new EventEmitter<number>();
  ListTracking: string[] = [];

  constructor(
    public dialog: MatDialog,
    private _CoreConfigService: CoreConfigService,
    private _HttpClient: HttpClient,
    public _TrackingService: TrackingService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private _ActivatedRoute: ActivatedRoute
  ) {}

  ToggleDetail() {
    this.ChangeShowDetail.next(this.index);
  }

  GetIconCode(code: string) {
    return code;
  }

  viewReturnPOD(con: string) {
    this.ListTracking = [con];
    window.location.href =
      window.location.origin +
      window.location.pathname +
      '?track=' +
      this._TrackingService.EncryptOldTrack(this.ListTracking);
  }
  viewsignature() {
    this.dialog.open(TrackingItemSignatureDialog, {
      data: this.info,
      height: 'auto',
      width: '500px',
    });
  }

  MarkMobile(mobile: string) {
    if (mobile != '' && mobile !== undefined && mobile != null) {
      let phoneMarking = '';
      for (let index = 0; index < mobile.length; index++) {
        phoneMarking =
          phoneMarking + (index < mobile.length - 3 ? '*' : mobile[index]);
      }
      mobile = phoneMarking;
    }

    return mobile;
  }

  async ShowMobile(shipment, index: string) {
    const isVerify = await this.VerifyPhone(shipment.shipment, 'ShowMobile');
    if (isVerify) {
      if (shipment.shipment_status.length > 0) {
        let courierExpandPhone: string[] = [];
        let callNumberExpandPhone: string[] = [];
        for (let index = 0; index < shipment.shipment_status.length; index++) {
          const current = shipment.shipment_status[index];
          if (
            current.courier_mobile != '' &&
            current.courier_mobile !== undefined &&
            current.courier_mobile != null
          ) {
            courierExpandPhone.push(shipment.shipment.con + '-' + current.indx);
          }
          if (
            current.call_number_unmark != '' &&
            current.call_number_unmark !== undefined &&
            current.call_number_unmark != null
          ) {
            callNumberExpandPhone.push(
              shipment.shipment.con + '-number-' + current.indx
            );
          }
        }

        for (let i = 0; i < courierExpandPhone.length; i++) {
          const elementShow = $('#' + courierExpandPhone[i] + '-show');
          elementShow.css('display', 'block');
          const elementHide = $('#' + courierExpandPhone[i] + '-hide');
          elementHide.css('display', 'none');
        }

        for (let i = 0; i < callNumberExpandPhone.length; i++) {
          const elementShow = $('#' + callNumberExpandPhone[i] + '-show');
          elementShow.css('display', 'block');
          const elementHide = $('#' + callNumberExpandPhone[i] + '-hide');
          elementHide.css('display', 'none');
        }
      }
    }
  }

  async HideMobile(shipment, index: string) {
    const isVerify = await this.VerifyPhone(shipment, 'HideMobile');
    if (isVerify) {
      const elementShow = $('#' + index + '-show');
      elementShow.css('display', 'none');
      const elementHide = $('#' + index + '-hide');
      elementHide.css('display', 'block');
    }
  }

  async ShowCallNumber(shipment, index: string) {
    const isVerify = await this.VerifyPhone(
      shipment.shipment,
      'ShowCallNumber'
    );
    if (isVerify) {
      if (shipment.shipment_status.length > 0) {
        let callNumberExpandPhone: string[] = [];
        let courierExpandPhone: string[] = [];
        for (let index = 0; index < shipment.shipment_status.length; index++) {
          const current = shipment.shipment_status[index];
          if (
            current.call_number_unmark != '' &&
            current.call_number_unmark !== undefined &&
            current.call_number_unmark != null
          ) {
            callNumberExpandPhone.push(
              shipment.shipment.con + '-number-' + current.indx
            );
          }
          if (
            current.courier_mobile != '' &&
            current.courier_mobile !== undefined &&
            current.courier_mobile != null
          ) {
            courierExpandPhone.push(shipment.shipment.con + '-' + current.indx);
          }
        }

        for (let i = 0; i < courierExpandPhone.length; i++) {
          const elementShow = $('#' + courierExpandPhone[i] + '-show');
          elementShow.css('display', 'block');
          const elementHide = $('#' + courierExpandPhone[i] + '-hide');
          elementHide.css('display', 'none');
        }

        for (let i = 0; i < callNumberExpandPhone.length; i++) {
          const elementShow = $('#' + callNumberExpandPhone[i] + '-show');
          elementShow.css('display', 'block');
          const elementHide = $('#' + callNumberExpandPhone[i] + '-hide');
          elementHide.css('display', 'none');
        }
      }
    }
  }

  async HideCallNumber(shipment, index: string) {
    const isVerify = await this.VerifyPhone(
      shipment.shipment,
      'HideCallNumber'
    );
    if (isVerify) {
      const elementShow = $('#' + index + '-show');
      elementShow.css('display', 'none');
      const elementHide = $('#' + index + '-hide');
      elementHide.css('display', 'block');
    }
  }

  async HideNameCustomer(shipment, index: string) {
    const isVerify = await this.VerifyPhone(
      shipment.shipment,
      'HideNameCustomer'
    );
    if (isVerify) {
      const elementShow = $('#' + index + '-show');
      elementShow.css('display', 'none');
      const elementHide = $('#' + index + '-hide');
      elementHide.css('display', 'block');
    }
  }

  async ShowNameCustomer(shipment, index: string) {
    const isVerify = await this.VerifyPhone(
      shipment.shipment,
      'ShowNameCustomer'
    );
    if (isVerify) {
      if (shipment.shipment_status.length > 0) {
        let courierExpandPhone: string[] = [];
        courierExpandPhone.push(shipment.shipment.con);
        for (let index = 0; index < shipment.shipment_status.length; index++) {
          const current = shipment.shipment_status[index];
          if (
            current.courier_mobile != '' &&
            current.courier_mobile !== undefined &&
            current.courier_mobile != null
          ) {
            courierExpandPhone.push(shipment.shipment.con + '-' + current.indx);
          }
        }

        for (let i = 0; i < courierExpandPhone.length; i++) {
          const elementShow = $('#' + courierExpandPhone[i] + '-show');
          elementShow.css('display', 'block');
          const elementHide = $('#' + courierExpandPhone[i] + '-hide');
          elementHide.css('display', 'none');
        }
      }
    }
  }

  viewphoto() {
    this.dialog.open(TrackingItemPhotoDialog, {
      data: this.info,
      height: 'auto',
      width: '350px',
    });
  }

  async viewproofPhoto(shipment) {
    const isVerify = await this.VerifyPhone(shipment?.shipment, 'proofPhoto');
    if (isVerify) {
      if (shipment.shipment_status.length > 0) {
        let courierExpandPhone: string[] = [];
        let callNumberExpandPhone: string[] = [];
        for (let index = 0; index < shipment.shipment_status.length; index++) {
          const current = shipment.shipment_status[index];
          if (
            current.courier_mobile != '' &&
            current.courier_mobile !== undefined &&
            current.courier_mobile != null
          ) {
            courierExpandPhone.push(shipment.shipment.con + '-' + current.indx);
          }
          if (
            current.call_number_unmark != '' &&
            current.call_number_unmark !== undefined &&
            current.call_number_unmark != null
          ) {
            callNumberExpandPhone.push(
              shipment.shipment.con + '-number-' + current.indx
            );
          }
        }

        for (let i = 0; i < courierExpandPhone.length; i++) {
          const elementShow = $('#' + courierExpandPhone[i] + '-show');
          elementShow.css('display', 'block');
          const elementHide = $('#' + courierExpandPhone[i] + '-hide');
          elementHide.css('display', 'none');
        }

        for (let i = 0; i < callNumberExpandPhone.length; i++) {
          const elementShow = $('#' + callNumberExpandPhone[i] + '-show');
          elementShow.css('display', 'block');
          const elementHide = $('#' + callNumberExpandPhone[i] + '-hide');
          elementHide.css('display', 'none');
        }
      }

      this.dialog.open(TrackingItemProofPhotoDialog, {
        data: this.info,
        height: 'auto',
        width: '500px',
        panelClass: 'view_proof_photo',
      });
    }
  }

  async viewRefundCOD(shipment) {
    const isVerify = await this.VerifyPhone(shipment?.shipment, 'codRefund');
    if (isVerify) {
      if (shipment.shipment_status.length > 0) {
        let courierExpandPhone: string[] = [];
        let callNumberExpandPhone: string[] = [];
        for (let index = 0; index < shipment.shipment_status.length; index++) {
          const current = shipment.shipment_status[index];
          if (
            current.courier_mobile != '' &&
            current.courier_mobile !== undefined &&
            current.courier_mobile != null
          ) {
            courierExpandPhone.push(shipment.shipment.con + '-' + current.indx);
          }
          if (
            current.call_number_unmark != '' &&
            current.call_number_unmark !== undefined &&
            current.call_number_unmark != null
          ) {
            callNumberExpandPhone.push(
              shipment.shipment.con + '-number-' + current.indx
            );
          }
        }

        for (let i = 0; i < courierExpandPhone.length; i++) {
          const elementShow = $('#' + courierExpandPhone[i] + '-show');
          elementShow.css('display', 'block');
          const elementHide = $('#' + courierExpandPhone[i] + '-hide');
          elementHide.css('display', 'none');
        }

        for (let i = 0; i < callNumberExpandPhone.length; i++) {
          const elementShow = $('#' + callNumberExpandPhone[i] + '-show');
          elementShow.css('display', 'block');
          const elementHide = $('#' + callNumberExpandPhone[i] + '-hide');
          elementHide.css('display', 'none');
        }
      }

     let isVerify = await this.openVerifyRefundCODDialog(shipment);
     if(isVerify)
     {
        this._ActivatedRoute.queryParams 
        .pipe(takeUntil(this.ngDestroyed$))
        .subscribe((queryParams: Params) => {
          if (queryParams && queryParams['track']) {
            let lang = window.location.pathname.split('/')[1] || 'en';
            //console.log(window.location.hostname+'/'+lang+'/track/cod_refund?con='+shipment?.shipment.con+'&track='+queryParams['track']);
            //console.log(window.location.hostname);
           // let url = window.location.hostname+'/'+lang+'/track/cod_refund?con='+shipment?.shipment.con+'&track='+queryParams['track'];
           //let url = 'http://10.112.85.112:9014'+'/'+lang+'/track/cod_refund?con='+shipment?.shipment.con+'&track='+queryParams['track'];
           const secretKey = '520-secret-key';  // 请使用较长且随机的密钥
            // 待加密的参数
            const type = String(shipment.refoundtype);
            // 进行 AES 加密
            const encrypted = CryptoJS.AES.encrypt(type, secretKey).toString();
            const typeParam = encodeURIComponent(encrypted);
           let apiUrl = ['th.kex-express.com','th.kerryexpress.com'].includes(window.location.hostname) ?  `https://${window.location.hostname}`  :  'http://10.112.85.112:9014' // 'http://localhost:9014' //;
          apiUrl +=  '/'+lang+'/track/cod_refund/?con='+shipment?.shipment.con+'&track='+queryParams['track'] + '&isCreate=' + typeParam;

              const fullUrl = apiUrl;
              window.open(fullUrl, '_self');
            }
          });
      }
    }
  }

  async viewCODDocument(shipment) {
    const isVerify = await this.VerifyPhone(
      shipment?.shipment,
      'viewCODDocument'
    );
    if (isVerify) {
      if (shipment.shipment_status.length > 0) {
        let courierExpandPhone: string[] = [];
        let callNumberExpandPhone: string[] = [];
        for (let index = 0; index < shipment.shipment_status.length; index++) {
          const current = shipment.shipment_status[index];
          if (
            current.courier_mobile != '' &&
            current.courier_mobile !== undefined &&
            current.courier_mobile != null
          ) {
            courierExpandPhone.push(shipment.shipment.con + '-' + current.indx);
          }
          if (
            current.call_number_unmark != '' &&
            current.call_number_unmark !== undefined &&
            current.call_number_unmark != null
          ) {
            callNumberExpandPhone.push(
              shipment.shipment.con + '-number-' + current.indx
            );
          }
        }

        for (let i = 0; i < courierExpandPhone.length; i++) {
          const elementShow = $('#' + courierExpandPhone[i] + '-show');
          elementShow.css('display', 'block');
          const elementHide = $('#' + courierExpandPhone[i] + '-hide');
          elementHide.css('display', 'none');
        }

        for (let i = 0; i < callNumberExpandPhone.length; i++) {
          const elementShow = $('#' + callNumberExpandPhone[i] + '-show');
          elementShow.css('display', 'block');
          const elementHide = $('#' + callNumberExpandPhone[i] + '-hide');
          elementHide.css('display', 'none');
        }
      }

      // let lang = window.location.pathname.split('/')[1] || 'en';
      //console.log(window.location.hostname+'/'+lang+'/track/cod_refund?con='+shipment?.shipment.con);

      //const pdfUrl = 'https://kop-cod-receipt.obs.ap-southeast-2.myhuaweicloud.com/cod-voucher/5624b6f5742dc639e9ab0cdd0f4214a7.pdf';
      //this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.dialog.open(TrackingItemRefundCodPdfPreview, {
        width: '80%',
        height: '80%',
        data: { con: shipment?.shipment.con },
      });
    }
  }

  VerifyPhone(shipment, action): Promise<boolean> {
    let localVerifyPhone = localStorage.getItem('ListVerifyPhone');
    let localVerifyPhoneCOD = localStorage.getItem('ListVerifyPhoneCOD');
    this.ListVerifyPhone = JSON.parse(localVerifyPhone);
    this.ListVerifyPhoneCOD = JSON.parse(localVerifyPhoneCOD);
    if (this.ListVerifyPhone == null) this.ListVerifyPhone = [];
    if (this.ListVerifyPhoneCOD == null) this.ListVerifyPhoneCOD = [];
    return new Promise((resolve, reject) => {
      if (shipment != null) {
        let senderPhoneDigit = shipment.s_mobile.substring(
          shipment.s_mobile.length - 4
        );
        let recipientPhoneDigit = shipment.r_mobile.substring(
          shipment.r_mobile.length - 4
        );
        let caseAction;
        if (action == 'codRefund') {
          caseAction =
            this.ListVerifyPhoneCOD &&
            this.ListVerifyPhoneCOD.includes(recipientPhoneDigit);
        } else {
          caseAction =
            this.ListVerifyPhone &&
            (this.ListVerifyPhone.includes(senderPhoneDigit) ||
              this.ListVerifyPhone.includes(recipientPhoneDigit));
        }
        if (caseAction) {
          resolve(true);
        } else {
          const dialogRef = this.dialog.open(TrackingVerifyPhone, {
            data: { data: shipment, isVerify: true, action: action },
            height: 'auto',
            width: '500px',
          });
          dialogRef.afterClosed().subscribe((result) => {
            if(!result) {
              return  resolve(false);
            }
            const { isCheck } = result;
            const { r_mobile, s_mobile } = result?.data?.verifyShipment;
            
            senderPhoneDigit = s_mobile.substring(s_mobile.length - 4);
            recipientPhoneDigit = r_mobile.substring(r_mobile.length - 4);
            this.isExpand = isCheck;
            // 修改原始数据
            const shipmentData = this.tracking_data.ref.shipment;
            Object.assign(shipmentData, result?.data?.verifyShipment);
            const list = result.data?.verifyShipment_Status ?? [];
            const obj = {};
            list.forEach((v) => {
              v?.indx && (obj[v.indx] = v);
            });

            const { group_shipment_status, shipment_status } =
              this.tracking_data.ref;
            shipment_status.forEach((v) => {
              v?.indx && Object.assign(v, obj[v?.indx]);
            });

            for (const group of group_shipment_status) {
              const statusList = group?.shipment_status;
              if (!statusList) continue;

              for (const item of statusList) {
                const key = item?.indx;
                if (key == null) continue; // 排除 null/undefined
                const dataToMerge = obj[key];
                if (dataToMerge) {
                  Object.assign(item, dataToMerge);
                }
              }
            }

            if (!this.ListVerifyPhone.includes(senderPhoneDigit)) {
              this.ListVerifyPhone.push(senderPhoneDigit);
              localStorage.setItem(
                'ListVerifyPhone',
                JSON.stringify(this.ListVerifyPhone)
              );
            }
            if (!this.ListVerifyPhone.includes(recipientPhoneDigit)) {
              this.ListVerifyPhone.push(recipientPhoneDigit);
              localStorage.setItem(
                'ListVerifyPhone',
                JSON.stringify(this.ListVerifyPhone)
              );
              if (action == 'codRefund') {
                if (!this.ListVerifyPhoneCOD.includes(recipientPhoneDigit)) {
                  this.ListVerifyPhoneCOD.push(recipientPhoneDigit);
                  localStorage.setItem(
                    'ListVerifyPhoneCOD',
                    JSON.stringify(this.ListVerifyPhoneCOD)
                  );
                }
              }
            }
            resolve(true);
          });
        }
      } else {
        resolve(false);
      }
    });
  }

  ngOnInit(): void {
    localStorage.removeItem('ListVerifyPhone');
    localStorage.removeItem('ListVerifyPhoneCOD');
    this.showIframe = false;
  }
  ngOnDestroy() {
    this.ngDestroyed$.next();
    this.ngDestroyed$.complete();
  }
  ngFormateText(text: string): string {
    text = text.toUpperCase().trim();
    return text;
  }
  ngFormateStatusCode(code: string) {
    return code.length >= 3 ? code.substring(0, 3) : '';
  }

  ngCheckIndexDisplay(code: number, text: string): string {
    text = code > 0 ? text : '100_F';
    return text;
  }

  ngCheckIndexTextDisplay(code: number): number {
    code = code > 0 ? code : 0;
    return code;
  }

  openVerifyRefundCODDialog(shipment): Promise<boolean> {
    return new Promise((resolve, reject) => {
      resolve(true);
      // const dialogRef = this.dialog.open(TrackingVerifyPhoneRefund, {
      //   data: { data: shipment },
      //   height: 'auto',
      //   width: '500px',
      // });

      // dialogRef.afterClosed().subscribe(result => {
      //   let isVerify = result != undefined ? result : false;
      //   if(isVerify)  {
      //     resolve(true);
      //   }
      //   else
      //   {
      //     resolve(false);
      //   }
      // });
    });
  }
}
